
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const organisationService = {
    getOrganisationList
};

axios.defaults.headers.common = authHeader();

function getOrganisationList(id) {
    return axios.get('/users/seller/organisation/assessment/credit/list/' + id + '/')
        .then(response => {

            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/sellers/organisations.service.js